export const EMPTY_ALERT_RULE_TEMPLATE = {
  template_id: null,
  instructions: '',
  organization_instructions: '',
  ai_enabled: false,
  ai_escalation: false
};

export default EMPTY_ALERT_RULE_TEMPLATE;
